module.exports = __webpack_public_path__ + "static/media/school.541adf5f.jpg";